@use "../../styles/breakpoint.module.scss" as *;

.form {
    font: var(--font-p-16);
    overflow: hidden;

    --primary: var(--black);
    --secondary: var(--black);

    [data-design-version="v2024"] & {
        --primary: var(--red);
        --secondary: var(--gray);
    }

    :nth-last-child(1 of .group) {
        @media ($below-mobile) {
            margin-bottom: var(--spacer-32);

            [data-design-version="v2024"] & {
                margin-bottom: 32px;
            }
        }
    }
}

.group {
    margin-bottom: var(--spacer-40);
}

.groupName {
    composes: fontUppercase from "../../styles/composable/typography.module.css";
    display: block;
    font: var(--font-eyebrow-14, var(--font-p-10));

    [data-design-version="v2024"] & {
        margin-bottom: var(--spacer-16);

        + .item {
            padding-left: 0;
        }
    }

    [data-design-version="v2026"] & {
        padding-bottom: var(--spacer-12);
    }
}

.item {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid var(--gray-300, var(--white-gray));
    cursor: pointer;

    [data-design-version="v2024"] & {
        padding: var(--spacer-8);
    }

    [data-design-version="v2026"] & {
        padding-block: var(--spacer-12);
    }

    &[data-hovered] {
        color: var(--primary);
    }
}

.svg {
    --width: 20px;
    --border-width: 1px;

    [data-design-version="v2024"] & {
        --width: 16px;
        --border-width: 2px;
    }

    width: var(--width);
    height: var(--width);
    padding: 3px 2px;
    background-color: transparent;
    box-shadow: inset 0 0 0 var(--border-width) var(--secondary);
    fill: transparent;
    transition:
        box-shadow 0.2s,
        fill 0.2s;

    .item[data-hovered] &,
    .allHeader[data-hovered] & {
        box-shadow: inset 0 0 0 var(--border-width) var(--primary);
    }

    .item[data-selected] &,
    .allHeader[data-selected] & {
        box-shadow: inset 0 0 0 16px var(--primary);
        fill: var(--white);
    }

    .item[data-indeterminate] &,
    .allHeader[data-indeterminate] & {
        box-shadow: inset 0 0 0 16px var(--secondary);
        fill: var(--white);
    }
}

.fileType {
    margin-left: var(--spacer-8);
    font: var(--font-text-link-12, var(--font-p-10));
    text-decoration: underline;

    [data-design-version="v2024"] & {
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: var(--gray);
    }
}

.groupHeader {
    [data-design-version="v2026"] & {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: var(--spacer-16);
        border-bottom: 1px solid var(--primary);
    }
}

.selectAllLink {
    composes: fileType;
}

.allHeader {
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacer-16);
    width: 100%;
    margin-bottom: var(--spacer-40);
    padding-bottom: var(--spacer-12);
    border-bottom: 1px solid var(--primary);

    .groupName {
        padding-bottom: 0;
    }
}

.submit {
    [data-design-version="v2024"] & {
        float: right;
    }

    @media ($below-mobile) {
        [data-design-version="v2026"] & {
            display: block;
            margin-inline: auto;
        }
    }
}
